import type { DocsColumn, DocsData } from '../schemas/docs-data.js';

function sanitizeMermaidToken(name: string): string {
  return name.replace(/[^a-zA-Z0-9_]/g, '_');
}

function columnLine(column: DocsColumn): string {
  const type = sanitizeMermaidToken(column.dataType);
  const flag = column.primaryKey ? ' PK' : '';
  return `    ${type} ${column.name}${flag}`;
}

/**
 * Renders a Mermaid `erDiagram` block from generated schema data — relationship
 * lines first (one per foreign key, referenced table on the "one" side), then
 * one entity block per table listing its columns. Deterministic: same input
 * always produces the same string, since `DocsData`'s tables/columns/foreignKeys
 * arrays are already sorted by the generator.
 */
export function buildErdMermaid(data: DocsData): string {
  const lines: string[] = ['erDiagram'];

  for (const table of data.tables) {
    for (const fk of table.foreignKeys) {
      lines.push(
        `  ${sanitizeMermaidToken(fk.referencedTable)} ||--o{ ${sanitizeMermaidToken(table.name)} : "${fk.columns.join(', ')}"`,
      );
    }
  }

  for (const table of data.tables) {
    lines.push(`  ${sanitizeMermaidToken(table.name)} {`);
    for (const column of table.columns) {
      lines.push(columnLine(column));
    }
    lines.push('  }');
  }

  return `${lines.join('\n')}\n`;
}
